// A paid pack is sold at the price PaymentHub quotes for its SKU: the web-shop proxy attaches it
// as pack.paymentHub.price ({ amount in cents, ISO currency }), and init-payment refuses any other.
// When PaymentHub's catalog has no entry for the SKU the proxy substitutes
// { currency: 'missing', amount: <parsed from the SKU> }. No checkout can use that, and
// Intl.NumberFormat throws a RangeError on the currency, which takes down any view that formats
// it. Free packs never carry a price (the proxy skips them).
const ISO_CURRENCY = /^[A-Za-z]{3}$/;

// A price PaymentHub quoted: a numeric amount in cents and an ISO currency Intl can format. The
// strike-through's paymentHub.fullPrice needs the same test as price (its placeholder carried a
// numeric amount and currency 'missing').
export const isQuote = (price) =>
    Boolean(price)
    && Number.isFinite(price.amount)
    && typeof price.currency === 'string'
    && ISO_CURRENCY.test(price.currency);

export const hasPaymentHubPrice = (pack) => isQuote(pack?.paymentHub?.price);

// Splits a get-packs catalog into the packs the shop can show and the ids of the paid packs it
// has to hide, so a pack PaymentHub cannot price costs only itself, never the whole shop.
export const partitionByPrice = (packs) => {
    const sellable = [];
    const hiddenIds = [];
    for (const pack of packs) {
        if (pack?.isFreePack || hasPaymentHubPrice(pack)) sellable.push(pack);
        else hiddenIds.push(pack?.internalId);
    }
    return { sellable, hiddenIds };
};
